<template>
	<div
	v-touch:tap="tapHandler"
	v-touch:swipe.left="swipeLeftHandler"
	v-touch:swipe.right="swipeRightHandler"
	@contextmenu.prevent="contextMenuHandler"
	style="user-select: none;"
	@keyup.enter="tapHandler"
	tabindex="0"
	role="link"
	>

		<template v-if="data">

			<button class="btn btn-danger float-right" v-if="showDeleteBtn" v-touch:tap.stop="deleteItem">{{$t('delete')}}</button>

			<p class="mb-1">
				{{ data.caption }}
				<small class="text-muted" v-if="data.name">({{ data.name }})</small>
			</p>
			<span class="badge badge-primary badge-sm mr-2 mb-2" v-if="datasourceLabel">{{ datasourceLabel }}</span>
			<span class="badge badge-secondary badge-sm mr-2 mb-2" v-for="(badge, i) in filterBadges" :key="i">{{ badge }}</span>

		</template>

		<template v-else>

			{{$t('loading')}}

		</template>

	</div>
</template>

<script>
import datasources from "src/include/datasources";
import loadDataElementLookups from "src/include/dataelementlookups";

export default {
	props: ['data', 'swipedLeftItem', ],
	data() {
		return {
			lookups: {
				procedures: [],
				competencyTests: [],
				specialties: [],
				clinics: [],
				forms: [],
			},
		};
	},
	mounted() {
		loadDataElementLookups(this)
			.then((lookups) => {
				this.lookups = lookups;
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
	},
	created: function () {
	},
	destroyed: function () {
	},
	methods: {
		deleteItem() {
			this.$cfetch(`${this.$settings.APIBaseURL}/reporting/dataelements/deletedataelement/${this.data.id}`, {
				data: {}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$emit('removeItem', this.data);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		tapHandler(e) {

			// prevent tap for right clicks
			if(e.button && e.button == 2) {
				return false;
			}

			if(this.data) {
				this.$emit('selectItem', this.data);
			}
		},
		swipeLeftHandler() {
			this.$emit('swipeLeftItem', this.data);
		},
		swipeRightHandler() {
			this.$emit('swipeRightItem', this.data);
		},
		contextMenuHandler() {
			this.$emit('contextMenuItem', this.data);
		},
		findCaption(list, idKey, id, captionKey) {
			const item = (list || []).find((i) => i[idKey] == id);
			return item ? item[captionKey] : id;
		},
		findCaptions(list, idKey, ids, captionKey) {
			return ids.map((id) => this.findCaption(list, idKey, id, captionKey)).join(', ');
		},
		formatValue(value) {
			return Array.isArray(value) ? value.join(', ') : value;
		},
		describeParam(param) {
			const l = this.lookups;

			if ('ProcedureID' in param) {
				const caption = param.ProcedureID == '0' ? this.$t('all') : this.findCaption(l.procedures, 'ProcedureID', param.ProcedureID, 'Caption');
				return `${this.$t('procedure')}: ${caption}`;
			}
			if ('SessionTypeID' in param) {
				const type = (this.$config.getValue('participationTypes') || []).find((t) => t.id == param.SessionTypeID);
				return `${this.$t('session-type')}: ${type ? type.name : param.SessionTypeID}`;
			}
			if ('CompetencyTestAttachedID' in param) {
				return `${this.$t('test')}: ${this.findCaption(l.competencyTests, 'CompetencyTestID', param.CompetencyTestAttachedID, 'Name')}`;
			}
			if ('CompetencyTestID' in param) {
				return `${this.$t('only-after-test-passed')}: ${this.findCaption(l.competencyTests, 'CompetencyTestID', param.CompetencyTestID, 'Name')}`;
			}
			if ('SpecialtyID' in param) {
				return param.SpecialtyID.length ? `${this.$t('specialty')}: ${this.findCaptions(l.specialties, 'id', param.SpecialtyID, 'caption')}` : null;
			}
			if ('ClinicID' in param) {
				return param.ClinicID.length ? `${this.$t('clinic')}: ${this.findCaptions(l.clinics, 'id', param.ClinicID, 'name')}` : null;
			}
			if ('form_id' in param) {
				return param.form_id.length ? `${this.$t('form')}: ${this.findCaptions(l.forms, 'id', param.form_id, 'title')}` : null;
			}
			if ('formelement_name' in param) {
				return `${param.formelement_name}: ${this.formatValue(param.value)}`;
			}
			if ('formfield_name' in param) {
				if (param.min || param.max) {
					return `${param.formfield_name}: ${param.min || ''} - ${param.max || ''}`;
				}
				return `${param.formfield_name}: ${this.formatValue(param.value)}`;
			}
			if ('tags' in param) {
				if (!param.tags.length) {
					return null;
				}
				const names = param.tags.map((id) => {
					const tag = this.$config.getTagById(id);
					return tag ? tag.name : id;
				});
				return `${this.$t('tags')}: ${names.join(', ')}`;
			}
			if ('name' in param && 'value' in param) {
				if (param.name === 'competencytest_id') {
					return `${this.$t('test')}: ${this.findCaption(l.competencyTests, 'CompetencyTestID', param.value, 'Name')}`;
				}
				return `${param.name}: ${param.value}`;
			}
			if (param.completed) {
				return this.$t('completed');
			}
			if (param.reviewed) {
				return this.$t('reviewed');
			}
			if (param.signed_off) {
				return this.$t('signed-off');
			}
			if (param.user_subject) {
				return this.$t('form-is-about-another-user');
			}

			return null;
		},
	},
	computed: {
		showDeleteBtn() {
			return (this.swipedLeftItem && this.swipedLeftItem.id == this.data.id) && this.$UserSession.hasPriv.call(this, 'REPORTDATAELEMENTEDITOR');
		},
		parsedData() {
			// reportdataelement_data comes back from the API already decoded
			// (InvReportdataelementFile::initFromResult json_decodes it server-side)
			return this.data.data || {};
		},
		datasourceLabel() {
			const source = this.parsedData.datasource;
			if (!source) {
				return null;
			}
			return source in datasources ? this.$t(datasources[source]) : source;
		},
		filterBadges() {
			const d = this.parsedData;
			const badges = [];

			for (const param of (d.params || [])) {
				const badge = this.describeParam(param);
				if (badge) {
					badges.push(badge);
				}
			}

			for (const grade of (d.grades || [])) {
				badges.push(`${this.$t('grades')}: ${grade.caption}`);
			}

			for (const item of (d.ttsessiontypes || [])) {
				badges.push(`${this.$t('session-type')}: ${item.name}`);
			}

			for (const item of (d.not_ttsessiontypes || [])) {
				badges.push(`${this.$t('excludes-session-type')}: ${item.ttsessiontype_name || item.name}`);
			}

			if (d.date_range_from && d.date_range_from !== 'other') {
				badges.push(`${this.$t('date-range')}: ${this.$t('from')} ${this.$t('month-long-' + d.date_range_from)}`);
			} else if (d.date_range_from === 'other' && d.date_range_length) {
				const denominator = { MONTH: 'months', WEEK: 'weeks', DAY: 'days' }[d.date_range_denominator] || 'months';
				badges.push(`${this.$t('date-range')}: ${d.date_range_length} ${this.$t(denominator)}`);
			}

			return badges;
		},
	}
};
</script>
